/** ADR-0050: the trader's balance, top-ups, paying from the balance and fees in crypto. EN is the source; ru/es match. */
export default {
  nav: "Balance",
  chip: "Balance: {amount}",
  page: {
    title: "Balance",
    lead: "Top up in crypto, then pay for challenges, resets and activations in one tap.",
    available: "Available",
    topupTitle: "Top up",
    amount: "Amount, USD",
    amountHint: "From {min} to {max}",
    start: "Top up {amount}",
    noCrypto: "Top-ups are unavailable right now. Please write to support.",
    history: "History",
    empty: "Nothing yet. Top up to pay for a challenge from the balance.",
    continue: "Continue the purchase",
    credited: "Credited {amount}. The balance is ready to use.",
    open: "Waiting for payment",
    another: "New top-up",
    pay: "Pay",
    money: "Money",
    moneyHint: "What you paid in or got back. Withdrawable.",
    bonus: "Bonus",
    bonusHint: "A gift from the team: pays for challenges and fees, cannot be withdrawn. Spent after your money.",
    bonusBurns: "{amount} burns {at}",
    frozen: "Your balance is frozen: your identity check shows a country we cannot serve. Please write to support.",
  },
  moves: {
    topup: "Top-up",
    purchase: "Purchase",
    refund: "Refund",
    adjustment: "Correction by the team",
    overpay: "Paid over an order",
    bonus: "Bonus from the team",
    bonus_expired: "Bonus expired",
    withdrawal: "Withdrawal",
    withdrawal_released: "Withdrawal returned",
  },
  status: { awaiting_payment: "waiting for payment", paid: "credited", expired: "window closed", manual_review: "being checked", canceled: "cancelled" },
  pay: {
    method: "Balance",
    fromBalance: "Pay from balance",
    have: "On balance {amount}",
    short: "{short} short",
    topupAndPay: "Top up {amount} and pay",
    feeTitle: "Pay {amount}",
    feeLead: "Pay from your balance in one tap, or send crypto: the action runs by itself once the payment arrives.",
    feeFromBalance: "Pay {amount} from balance",
    feeCrypto: "Pay with crypto",
    feeTopup: "Top up the balance",
    feeWaiting: "Waiting for the payment — the page updates by itself.",
    feeDone: "Paid. Done.",
    feeKept: "The payment arrived, but the action could not run any more. The money is on your balance.",
    feeStart: "Show the address",
  },
  withdraw: {
    title: "Withdraw",
    lead: "Money on your balance goes to one of your payout wallets. The team checks every request and sends it by hand.",
    amount: "Amount, USD",
    min: "From {min}, up to {max}",
    to: "Send to",
    fee: "Network fee",
    net: "You receive",
    confirm: "Withdraw {amount}",
    sent: "Requested. The amount is held on your balance until the team sends it.",
    needKyc: "Withdrawals need an approved identity check.",
    goKyc: "Verify identity",
    needWallet: "Add a payout wallet first. A new address can be used once its waiting time has passed.",
    goWallet: "Payout wallets",
    belowMin: "The smallest withdrawal is {min}. Your money: {money}.",
    restricted: "Withdrawals are not available for your country of residence. Please write to support.",
    history: "Withdrawals",
    status: { requested: "waiting", prepared: "being checked", paid: "sent", rejected: "rejected" },
    refund: "Refund to your wallet",
  },
  errors: {
    insufficient_balance: "Not enough on the balance.",
    topups_open: "You already have three open top-ups. Pay one of them or wait until its window closes.",
    topup_amount: "A top-up is from {min} to {max}.",
    rail_busy: "This network is busy right now. Choose another coin.",
    pay_from_balance: "Your balance covers it — pay from the balance.",
    payments_not_live: "Top-ups are unavailable right now.",
    withdrawal_min: "A withdrawal is at least {min}.",
    withdrawal_open: "You already have a withdrawal waiting. Wait until the team decides on it.",
    kyc: "Withdrawals need an approved identity check.",
    restricted_country: "Not available for your country of residence.",
    wallet_not_ready: "This wallet cannot be used yet: it is new or did not pass screening.",
    balance_frozen: "Your balance is frozen. Please write to support.",
  },
  admin: {
    tab: "Balances",
    lead: "Balances of traders, their moves and corrections. A correction needs a second person to approve it.",
    search: "E-mail, name or user id",
    find: "Find",
    user: "Trader",
    balance: "Balance",
    requested: "Waiting for approval",
    none: "Nothing here.",
    amount: "Amount (+ credit, − debit)",
    reason: "Reason (what happened, a ticket number)",
    ask: "Ask for the correction",
    asked: "Asked. Another person approves it.",
    credit: "Book it now",
    credited: "Booked: your balance is updated.",
    approve: "Approve",
    reject: "Reject",
    rejectReason: "Why it is rejected",
    moves: "Moves",
    adjustments: "Corrections",
    by: "asked by {name}",
    close: "Close",
    pot: "Pot",
    potMoney: "Money — withdrawable",
    potBonus: "Bonus — burns in 7 days",
    money: "Money",
    bonus: "Bonus",
    restricted: { sanctioned: "Sanctioned country: balance frozen", us: "US resident: no payouts or withdrawals" },
    usRefund: {
      title: "Refund a US resident",
      lead: "Refunds every purchase to the money pot (fees too, bonus burns), closes all accounts and holds the whole money pot for sending to the wallet. Then it is sent like any withdrawal.",
      wallet: "Wallet",
      run: "Refund and close accounts",
      done: "Done: {amount} held for the wallet.",
      noWallet: "No wallet is ready: the person has to add one (a new address waits its delay).",
    },
    withdrawals: {
      title: "Withdrawals",
      lead: "Send by hand from the owner's wallet, then approve with the transaction hash. Who prepares does not approve.",
      prepare: "Prepare",
      approve: "Sent — approve",
      reject: "Reject",
      rejectReason: "Rejected in review",
      txHash: "Transaction hash",
      ownPrepared: "Prepared by you: another person approves",
      net: "net {amount}",
      none: "No withdrawals.",
    },
    kind: { topup: "Balance top-up", fee: "Fee payment" },
    status: { requested: "waiting", approved: "approved", rejected: "rejected" },
  },
} as const;
